module.exports = __webpack_public_path__ + "static/media/sunset-palm.032a285c.webp";